<template>
  <div>
    <span class="def-bt white" @click="setStep(1)" v-if="step==0">{{messages.startBtn}}</span>
    <div class="phoneSend" v-if="step==1">
      <div class="row">
        <div class="col-md-9 col-sm-9 col-9">
          <MaskInput ref="phone" class="phone" mask="+38 (0##) ###-##-##" v-model="phone" type="text" :masked="true" placeholder="+38 (0__) ___-__-__"/>
        </div>
        <div class="col-md-3 col-sm-3 col-3">
          <span class="def-bt white" @click="sendSms()">{{messages.sendBtn}}</span>
        </div>
      </div>
    </div>
    <div class="phoneSend" v-if="step==2">
      <div class="smsMessage">
        {{smsMessage}}
      </div>
      <div class="row">
        <div class="col-md-5">
          <div v-if="resendAfter>0" class="phoneSend">
            {{messages.resendAfter}}: {{smsResendTime}}
          </div>
          <div v-else class="phoneSend">
            <span @click="sendSms()" class="smollLink">{{messages.resendBtn}}</span>
            <span @click="setStep(1)" class="smollLink">{{messages.setNumberBtn}}</span>
          </div>
        </div>
        <div class="col-md-4  col-sm-9 col-9">
          <input type="text" v-model="confirmCode" class="smsConfirm">
        </div>
        <div class="col-md-3  col-sm-3 col-3">
          <span class="def-bt white" @click="compareSms()">{{messages.sendBtn}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MaskInput } from 'vue-3-mask';
export default {
  name: "buy_one_click",
  props:{messages: Object},
  components: {MaskInput},
  data() {
    return {
      step:0,
      smsMessage:this.messages.confirmMessage,
      resendAfter:10,
      confirmCode:"",
      phone:""
    }
  },
  methods:{
    setStep(step) {
      this.step = step;
      if(step==1) {
        Vue.nextTick(() => {
          //this.$refs.phone.focus();
        });
      }
    },
    async sendSms(e,confirmCode) {
      const requestParams = {
        phone: this.phone,
        handler: "order",
        func: "makeOneClickOrder"
      };
      if(confirmCode && confirmCode!==undefined) {
        requestParams['confirmCode'] = confirmCode;
      }
      const {status, data:responseData} = await axios.post(this.messages.orderlink, requestParams);
      if(status!==200) {
        alert("БЕДА");
      }
      if(responseData['status']==="SMS") {
        this.setStep(2);
        this.smsMessage = this.messages.confirmMessage;
        let now = new Date();
        this.resendAfter = Math.round(responseData['nextSMS'] - (now.getTime()/1000));
      } else if(responseData['status']==="BED_CONFIRM") {
        this.smsMessage = this.messages.bedText;
      } else if(responseData['status']==="ORDER_ADD") {
        let d = new Date();
        d.setTime(d.getTime() + 3600000);
        document.cookie = "ORDER_ID=" + responseData['id'] + ";expires=" + d.toUTCString() + ";path=/";
        localStorage.setItem("ORDER_ID",responseData['popupLink']);
        if(responseData['link']) {

          location.href = responseData['link'];
        }
      }
    },
    compareSms() {
      this.sendSms(null,this.confirmCode);
    }
  },
  computed: {
    smsResendTime() {
      let t = "";
      if(this.resendAfter<60) {
        t = this.resendAfter+' '+this.messages.timeText.s;
      } else if(this.resendAfter<3600) {
        t = Math.floor(this.resendAfter / 60) + ' ' + this.messages.timeText.m;
        let ost = Math.floor(this.resendAfter % 60);
        if (ost > 0) {
          t += " " + ost + ' ' + this.messages.timeText.s;
        }
      } else {
        t = Math.floor(this.resendAfter / 3600) + ' ' + this.messages.timeText.h;
      }
      if(this.resendAfter>0) {
        setTimeout(()=>{this.resendAfter--;},1000);
      }
      return t;
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.phone, .smsConfirm, .smsMessage {
  margin-top: 10px;
}
.smollLink {
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  display: block;
  margin-top: 3px;
}
@media (max-width: 420px) {
  .smsMessage, .phoneSend {
    font-size: 12px;
  }
  .phoneSend .smollLink {
    display: inline-block;
    margin-right: 10px;
    font-size: 12px;
  }
}
</style>